import {
  SET_DATA_FIELD,
  SET_IMAGE_GROUP,
  SET_IMAGE_HEADER,
  SET_OPEN_MENU,
  SET_HEADER_TITLE,
  SET_MODE_HISTORY,
} from "./constants";

export const setOpenMenu = (payload: any) => ({
  type: SET_OPEN_MENU,
  payload,
});

export const setHeaderTitle = (payload: any) => ({
  type: SET_HEADER_TITLE,
  payload,
});

export const setImageGroup = (payload: string) => ({
  type: SET_IMAGE_GROUP,
  payload,
});

export const setUpdateHeader = () => ({
  type: SET_IMAGE_HEADER,
});

export const setDataFieldByMode = (payload: any) => ({
  type: SET_DATA_FIELD,
  payload,
});

export const setModeHistory = (payload: any) => ({
  type: SET_MODE_HISTORY,
  payload,
});
